import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxFormComponent, DxPopupComponent } from 'devextreme-angular';
import { ConstantsService } from 'src/app/services/constants.service';
import { SessionContextService } from 'src/app/services/session-context.service';
import { TerminalData, TerminalService } from 'src/app/services/terminal.service';
import { Terminal } from '../../model/Terminal.model';
import { environment } from "../../../../environments/environment"
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { take } from 'rxjs/operators';
import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import DataSource from 'devextreme/data/data_source';
import { EventService } from 'src/app/services/event.service';
import { Subscription } from 'rxjs';
import { Branch } from '../../model/Branch.model';

export class TerminalSelection {
  terminal: Terminal = null;
  returnUrl: string = '';
}

@Component({
  selector: 'app-terminal-selection',
  templateUrl: './terminal-selection.component.html',
  styleUrls: ['./terminal-selection.component.css']
})
export class TerminalSelectionComponent implements OnInit {
  @Output() CloseDlg: EventEmitter<TerminalSelection> = new EventEmitter<TerminalSelection>();
  @ViewChild(DxPopupComponent) popup: DxPopupComponent;
  @ViewChild(DxFormComponent) form: DxFormComponent;
  terminalData: TerminalData = new TerminalData();
  selectedTerminal: TerminalSelection = new TerminalSelection();
  tillDrawerLookup: any = null;
  AllowTillConnected: boolean = false;
  showCancel: boolean = false;
  visitorId: any;
  returnUrl: string = '';
  onBranchChanged$: Subscription;
  selectedTerminalId: number = -1;
  terminalList: Terminal[] = [];
  terminalDataStore: any = null;

  constructor(
    private events: EventService,
    private session: SessionContextService,
    private terminalService: TerminalService,
    public constants: ConstantsService,
    private route: Router
  ) {
    this.onBranchChanged$ = this.events.onBranchChanged.subscribe((b: Branch) => {
      this.terminalDataStore = new DataSource({
        store: AspNetData.createStore({
          key: 'Id',
          loadUrl: '/api/LookupData/GetTerminalLookup?OnlyActive=1',
          onBeforeSend: (e, ajax) => {
            ConstantsService.AddDefaultHeaders(e, ajax);
          },
          onLoaded: (result) => {
            this.terminalList = result;
          },
        }),
        filter: ['Branch', '=', this.session.ctx.BranchId],
      });
      this.terminalDataStore.load();
    });

    this.btnOk = this.btnOk.bind(this);

    if (environment.production == false) {
      this.showCancel = true;
    }

    (async () => {
      // We recommend to call `load` at application startup.
      const fp = await FingerprintJS.load();

      // The FingerprintJS agent is ready.
      // Get a visitor identifier when you'd like to.
      const result = await fp.get();

      // This is the visitor identifier:
      this.visitorId = result.visitorId;

    })();
  }

  onTerminalChanged(e: any) {
    const terminal = this.terminalList.find((i) => i.Id === e?.value);
    this.selectedTerminal = { returnUrl: this.returnUrl, terminal: terminal };
    if (this.terminalData) {
      this.terminalData.IPAddress = terminal.IPAddress;
      this.terminalData.Name = terminal.Name;
      this.terminalData.TillConnected = terminal.TillConnected;
      this.terminalData.TillId = terminal.TillDrawerId;
    };
    this.session.selectTerminal(terminal.Id);
  }

  ngOnInit(): void {
    this.popup.visible = true;
  }

  OKButtonOptions = {
    text: 'OK',
    onClick: this.btnOk.bind(this)
  };

  CancelButtonOptions = {
    text: 'Cancel',
    onClick: this.btnCancel.bind(this)
  };

  public show(returnUrl: string) {
    // Check to see if terminal exists in current data
    this.returnUrl = returnUrl;
    this.selectedTerminal.returnUrl = returnUrl;

    let TerminalIPMadeUp: boolean = false;
    let TerminalIP = this.session.ctx.TerminalIP;

    // If no IP Address from HWC, look in localStorage and if nothing there make one up and save it to local storage
    if (TerminalIP == undefined || TerminalIP == '') {
      TerminalIP = localStorage.getItem("TerminalIPAddress");
      if (TerminalIP == undefined) {
        // let i1: number = Math.floor(Math.random() * 155) + 100;
        // TerminalIP = "192.168." + i1.toString() + "." + i1.toString();
        TerminalIP = this.visitorId.toString();
        localStorage.setItem("TerminalIPAddress", TerminalIP);
      }
      TerminalIPMadeUp = true;
    }

    let t: Terminal = this.session.GetTerminal(TerminalIP, this.session.ctx.BranchId);
    if (t) {
      // Select terminal
      this.session.selectTerminal(t.Id);
      this.selectedTerminal.terminal = t;
      this.selectedTerminalId = t.Id;
      // Close dlg with true = We have selected terminal
      // this.CloseDlg.emit(this.selectedTerminal);
      // return;
    }

    // show dlg to allow user to register new terminal
    this.popup.visible = true;
    this.terminalData.Name = this.session.GetSelectedBranch().BranchName + " Terminal " + TerminalIP;
    this.terminalData.IPAddress = TerminalIP;
    this.terminalData.BranchUID = this.session.GetSelectedBranch().UID;

    // Only add TillDrawer Data if selected branch matches HWCInfo branch UID
    if (this.session.ctx.HWCInfo?.BranchUId == this.session.GetSelectedBranch().UID) {
      this.tillDrawerLookup = this.session.ctx.HWCInfo.TillDrawers;

      // Save Terminal IP to local storage
      localStorage.setItem("TerminalIPAddress", this.session.ctx.TerminalIP);
      this.terminalData.TillConnected = true;
      this.AllowTillConnected = true;
    } else {
      this.tillDrawerLookup = [];
      // If no HWC and we have Madeup IP then allow till connection as they will have manual till and Manual Bed Control so they need to make sales.
      if (TerminalIPMadeUp == true) {
        this.AllowTillConnected = true;
      } else {
        this.AllowTillConnected = false;
      }
    }

    if (!this.selectedTerminal.terminal && this.terminalList?.length > 0) {
      if (this.terminalData.IPAddress) {
        t = this.terminalList.find(
          (i) => i.IPAddress == this.terminalData.IPAddress && i.Branch == this.session.ctx.BranchId
        );
      }

      if (!t) {
        t = this.terminalList[0];
      }

      this.session.selectTerminal(t.Id);
      this.selectedTerminal.terminal = t;
      this.selectedTerminalId = t.Id;
      this.terminalData.IPAddress = t.IPAddress;
      this.terminalData.Name = t.Name;
      this.terminalData.TillConnected = t.TillConnected;
      this.terminalData.TillId = t.TillDrawerId;
    }
  }

  btnCancel(e) {
    this.popup.visible = false;
    this.session
      .selectEmployee(-1, '')
      .pipe(take(1))
      .subscribe((r) => {
        this.route.navigate[r.Msg];
      });
  }

  btnOk(e) {
    this.popup.visible = false;

    // Save terminal data to DB
    // Update default data then select terminal
    this.terminalService
      .RegisterTerminal(this.terminalData)
      .pipe(take(1))
      .subscribe((r) => {
        this.popup.visible = false;
        let t: Terminal = this.session.selectTerminal(r.Id);
        this.selectedTerminal.terminal = t;
        this.CloseDlg.emit(this.selectedTerminal);
      });
  }
}